// extracted by mini-css-extract-plugin
export default {"cardsContainer":"MetricCards_cardsContainer__nIbXc"};